import { createSlice, isAnyOf } from "@reduxjs/toolkit"
import { zoomToShowFirePerimeter, zoomToShowHotspotsInFlightPath, zoomToShowPoints } from "./thunks"
import { ZoomState } from "./types"

const initialState = {
    byFlightId: {},
    allFeatures: undefined,
    next: undefined,
} as ZoomState

export const slice = createSlice({
    name: "zoom",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        return builder.addMatcher(
            isAnyOf(
                zoomToShowFirePerimeter.fulfilled,
                zoomToShowHotspotsInFlightPath.fulfilled,
                zoomToShowPoints.fulfilled
            ),
            (state, action) => {
                const { boundaryBox } = action.payload

                state.next = boundaryBox
            }
        )
    },
})

const { reducer } = slice

export default reducer
